import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import { EleConfigFileType } from './EleConfigFileType';
import { VendorEleFileConfigFieldEnum as Fields } from 'Common/FieldEnum';
import EleConfigFieldsContainer from './EleConfigFields';
import CustomerInfoContainer from './CustomerInfo';
import { VendorElectronicFileTypesEnum as FileTypes } from 'Common/Constants/Enumeration/VendorElectronicFileTypesEnum';

class ElectronicFileConfigFields extends Component {
  render() {
    const { fileFormat, configData } = this.props;
    let fieldComponent = null;
    if (fileFormat === FileTypes.USFOOD) {
      fieldComponent = (
        <label>
          <i className="info circle icon" />
          U.S. Foodservice, Inc. Standard #2 (ST2 - Fixed Width)
        </label>
      );
    } else if (fileFormat === FileTypes.SYSCO) {
      fieldComponent = (
        <label>
          <i className="info circle icon" />
          Sysco - Fixed Width
        </label>
      );
    } else {
      fieldComponent = (
        <Field
          component={EleConfigFieldsContainer}
          name={Fields.FileFields}
          {...{
            dataSource: configData[Fields.InvVFFFieldInfoModel],
          }}
        />
      );
    }
    return (
      <Grid style={{ marginTop: 15 }}>
        <Grid.Row>
          <Grid.Column>
            <Field component={EleConfigFileType} name={Fields.FileFormat} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <label className={'text-orange'}>Fields</label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>{fieldComponent}</Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <label className={'text-orange'}>
              Distributors Customer Information
            </label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <label>
              Please provide a Distributor customer Id / Contract Id for each
              site below
            </label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={CustomerInfoContainer}
              name={Fields.CustomerInfo}
              {...{
                dataSource: configData[Fields.SiteId],
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default ElectronicFileConfigFields;



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/ElectronicFileConfigFields.js